import { useTranslation } from 'react-i18next'
import { useClearRefinements, useCurrentRefinements } from 'react-instantsearch'
import {
  ActiveRefinementLabel,
  ClearRefinementsButton,
  ColorBackground,
  FlexContainer,
  RemoveRefinementBadge,
  StyledClosedIcon,
} from './styles'

interface ActiveRefinementsProps {
  isSticky: boolean
}

export const ActiveRefinements = ({ isSticky }: ActiveRefinementsProps) => {
  const { t } = useTranslation('collection-filters')
  const { items, canRefine } = useCurrentRefinements()
  const { refine: clearRefinements } = useClearRefinements()

  return canRefine ? (
    <ColorBackground isSticky={isSticky}>
      <FlexContainer>
        <ActiveRefinementLabel>{t('selectedFilters')}</ActiveRefinementLabel>
        {items.map(({ refinements, refine }) =>
          refinements.map((refinement) => {
            // TODO: evitare questa duplicazione e trasformarla in una funzione in utils
            const label = refinement.label.split('||')[0]
            const formattedLabel = label.replaceAll('-', ' ')

            return (
              <RemoveRefinementBadge
                key={refinement.label}
                onClick={() => {
                  refine(refinement)
                }}
              >
                <StyledClosedIcon width="13" height="13" />
                {formattedLabel}
              </RemoveRefinementBadge>
            )
          }),
        )}
        <ClearRefinementsButton onClick={clearRefinements}>
          <StyledClosedIcon width="13" height="13" />
          {t('clearFilters')}
        </ClearRefinementsButton>
      </FlexContainer>
    </ColorBackground>
  ) : null
}
